import { Roles } from "../../../constants/roles";
import { FormBase } from "../../../util/form-base-form";

class SearchCategoryModalForm extends FormBase {
    public getOverlay(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_CATEGORY_MODAL_OVERLAY}"]`, HTMLElement);
    }

    public getModal(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_CATEGORY_MODAL}"]`, HTMLElement);
    }

    public getList(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_CATEGORY_MODAL_LIST}"]`, HTMLElement);
    }

    public getFilterInput(root: ParentNode = document): HTMLInputElement | null {
        return this.getInput(root, `[data-role="${Roles.SEARCH_CATEGORY_MODAL_FILTER}"]`);
    }

    public getShowAllToggle(root: ParentNode = document): HTMLInputElement | null {
        return this.getInput(root, `[data-role="${Roles.SEARCH_CATEGORY_MODAL_SHOW_ALL_TOGGLE}"]`);
    }

    public getCloseButton(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.SEARCH_CATEGORY_MODAL_CLOSE}"]`, HTMLElement);
    }
}

const searchCategoryModalForm = new SearchCategoryModalForm();

export { SearchCategoryModalForm, searchCategoryModalForm };
